import { formatValor } from '@common/utils'
import textos from '../assets/textos.json'
import * as styles from './Llegenda.module.scss'
import { KEY_VOTS_ALIANCA } from '../App'

export default function Llegenda({ selectedLayer, valorsMinMax, lang }) {
	const tipusDades = textos[lang]?.tipusDades ?? []
	const dadaActiva = tipusDades?.find((dada) => dada.key === selectedLayer)

	return (
		<div className={styles.container}>
			<div className={styles.escala}>
				<span>{formatValor(valorsMinMax?.[KEY_VOTS_ALIANCA]?.min ?? '', 0)}</span>
				<span>{formatValor(valorsMinMax?.[KEY_VOTS_ALIANCA]?.max ?? '', 0)}%</span>
			</div>
			<div
				className={styles.barra}
				style={{ background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #005DAD 100%)' }}
			></div>
			{selectedLayer && (
				<>
					<div className={styles.escala}>
						<span>{formatValor(valorsMinMax?.[selectedLayer]?.min ?? '', 0)}</span>
						<span>
							{formatValor(valorsMinMax?.[selectedLayer]?.max ?? '', 0)}
							{dadaActiva?.unitat}
						</span>
					</div>
					<div
						className={styles.barra}
						style={{ background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #000 100%)' }}
					></div>
				</>
			)}
		</div>
	)
}
